import React from "react"
import Breadcrumb from "../../../design_system/application/components/page_breadcrumb"

export default ({ pages }, railsContext) => {
  return () => <Breadcrumb pages={pages} />
}
